import React, { useState } from 'react';
import { Card, CardBody, CardTitle, Input, Label, FormGroup } from 'reactstrap';
import { toast } from 'react-toastify';
import { ROLES } from '../../config/permissions.js';

const UserRolesSection = ({ user, quoteToolClient, onUpdate, currentUserId }) => {
    const [updatingRole, setUpdatingRole] = useState(null);

    const handleToggleRole = async (role) => {
        try {
            setUpdatingRole(role);
            const hasRole = user.roles.includes(role);
            const newRoles = hasRole
                ? user.roles.filter(r => r !== role)
                : [...user.roles, role];

            // Remove "no-role" if we're adding any real role
            if (!hasRole && role !== 'no-role') {
                const idx = newRoles.indexOf('no-role');
                if (idx > -1) newRoles.splice(idx, 1);
            }

            const updatedUser = await quoteToolClient.patchUser({
                userId: user.id,
                patch: { roles: newRoles }
            });
            onUpdate(updatedUser);
            toast.success(`Role ${hasRole ? 'removed' : 'added'} successfully`);
        } catch (error) {
            console.error('Error updating user roles:', error);
            toast.error('Failed to update user roles');
        } finally {
            setUpdatingRole(null);
        }
    };

    const formatRoleLabel = (role) => {
        return role.split('-').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
    };

    const isSelf = user.id === currentUserId;
    const isDisabled = (role) => isSelf || updatingRole === role;

    return (
        <Card>
            <CardBody>
                <CardTitle tag="h5">Roles & Permissions</CardTitle>

                {isSelf && (
                    <p className="text-muted fst-italic mb-3">
                        You cannot modify your own roles to prevent accidental loss of admin access.
                    </p>
                )}

                <ul className="user-roles-list">
                    {ROLES.map((role) => {
                        const hasRole = user.roles.includes(role);
                        const roleId = `role-${role}`;

                        return (
                            <li key={role}>
                                <FormGroup check>
                                    <Input
                                        type="checkbox"
                                        id={roleId}
                                        checked={hasRole}
                                        onChange={() => handleToggleRole(role)}
                                        disabled={isDisabled(role)}
                                    />
                                    <Label check for={roleId}>
                                        {formatRoleLabel(role)}
                                        {updatingRole === role && <span className="ms-2 text-muted">(updating...)</span>}
                                    </Label>
                                </FormGroup>
                            </li>
                        );
                    })}
                </ul>
            </CardBody>
        </Card>
    );
};

export default UserRolesSection;
